import { useContext } from 'react';
import { IIndoorStandWorldMarker } from 'react-give-me-map';
import { CtxEdit } from 'session/ctxEdit';

import { SelectedMarkerIconCommon } from 'components/site/general/singleSelect/SelectedMarkerV2/SelectedMarkerIconCommon';
import 'components/site/general/singleSelect/SelectedMarkerV2/style.css';

interface Props {
    markerId: string;
}

export const SelectedMarkerIndoorStand = (props: Props) => {
    const ctxEdit = useContext(CtxEdit);

    const markers = ctxEdit.worldMarkers.filter(
        (e): e is IIndoorStandWorldMarker => e.elementType === 'indoor_stand'
    );

    return (
        <SelectedMarkerIconCommon
            markerId={props.markerId}
            type={'indoor_stand'}
            allMarkersOfType={markers}
        />
    );
};
